import React from 'react';

import styled from '@emotion/styled';

import LargeDotIcon from '../../Icons/LargeDotIcon';

interface PerformanceHistoryLegendProps {
  label: string;
}
const PerformanceHistoryLegend: React.FC<PerformanceHistoryLegendProps> = ({
  label,
}) => {
  return (
    <Container>
      <XLabel>{label}</XLabel>
      <WeightedScore>
        Weighted Score <LargeDotIcon />
      </WeightedScore>
    </Container>
  );
};

export default PerformanceHistoryLegend;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 10px;
  color: #6e7079;
`;

const WeightedScore = styled.div`
  color: ${({ theme }) => theme.palette.blueColor};
  font-weight: 700;
  padding: 8px 12px;
  border-radius: 24px;
  background-color: rgba(91, 145, 245, 0.05);
  width: fit-content;
  align-self: center;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const XLabel = styled.div`
  font-weight: 400;
  margin-bottom: 12px;
  color: #6e7079;
`;
